export const STORAGE_KEYS = {
	accessToken: 'accessToken',
	refreshToken: 'refreshToken',
	tokenExpiresAt: 'tokenExpiresAt'
} as const;
